import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { PartialRestoreType } from '@repo/api-gw-sdk';
import type { RestoreJob } from '@repo/api-gw-sdk';
import { PathLink } from '@/components/explorer/fileLink';
import { useDAL } from '@/contexts/useDAL';
export const PartialRestoreDataField = t0 => {
  const $ = _c(3);
  const {
    entity
  } = t0;
  const resourceId = entity.resourceDetails?.id;
  if (!resourceId) {
    return null;
  }
  let t1;
  if ($[0] !== entity || $[1] !== resourceId) {
    t1 = <PartialRestoreDataFieldInner entity={entity} resourceId={resourceId} />;
    $[0] = entity;
    $[1] = resourceId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const PartialRestoreDataFieldInner = ({
  entity,
  resourceId
}: {
  entity: RestoreJob;
  resourceId: string;
}) => {
  const dal = useDAL();
  const {
    data: body
  } = dal.inventory.useResource(resourceId || '');
  if (entity.partialRestoreData?.partialRestoreType === PartialRestoreType.FilesPartialRestoreData) {
    if (!body?.resource) {
      return null;
    }
    return entity.partialRestoreData?.files?.files.length && <Stack sx={{
      gap: '8px'
    }}>
          {entity.partialRestoreData?.files?.files.map(file => <PathLink key={file.path} entity={body?.resource} path={file.path} pathType={file.pathType} />)}
        </Stack>;
  } else {
    const id = entity.partialRestoreData?.awsEbsVolume?.providerVolumeId || entity.partialRestoreData?.azureDisk?.diskId || entity.partialRestoreData?.gcpDisk?.diskId;
    return id && <Typography>{id}</Typography>;
  }
};